// @ts-nocheck — composes a ported page. See src/crm/README.md.
import { withProspectsAccess } from "@crm-src/components/page-permission-guard"

import { ProspectsListPage } from "./ProspectsPage"

/**
 * The reseller's Prospects list: the ported list page with the `all` origin
 * (prospects-origin.ts), so every lead XOP attached to this reseller is
 * listed whatever its source. The default export of ProspectsPage.tsx is the
 * command center's `regular` mount and stays untouched for diffability.
 */
function ResellerProspects() {
  return <ProspectsListPage origin="all" />
}

export const ResellerProspectsPage = withProspectsAccess(ResellerProspects)
